function authentication(state = {}, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        loginToken: action.loginToken
      };
    case "LOGIN_ERROR":
      return {
        loginToken: action.loginToken,
        error: true,
        message: "We konden je niet inloggen met de ingevoerde gegevens"
      };
    default:
      return state;
  }
  return state;
}

export default authentication;



// WEBPACK FOOTER //
// ./reducers/authentication.js